module.exports = __webpack_public_path__ + "static/media/heatmap.a1b7047c.svg";